import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["track", "slide"];

  static values = {
    currentIndex: { type: Number, default: 0 },
    categoryKey: String,
    slideGap: { type: Number, default: 24 }, // 1.5rem = 24px (gap-6)
  };

  connect() {
    if (this.slideTargets.length === 0) {
      console.warn("Carousel connected but no slides found");
      return;
    }

    // Initialize carousel
    this.updateCarousel();

    // Add resize listener for responsive behavior
    this.resizeObserver = new ResizeObserver(() => {
      this.updateCarousel();
    });
    this.resizeObserver.observe(this.element);
  }

  disconnect() {
    // Clean up event listeners when controller disconnects
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  // Navigation methods with wrap-around behavior
  next() {
    this.goToSlide((this.currentIndexValue + 1) % this.slideTargets.length);
  }

  previous() {
    this.goToSlide(
      (this.currentIndexValue - 1 + this.slideTargets.length) %
        this.slideTargets.length,
    );
  }

  // Main control method
  goToSlide(index) {
    // Ensure the index is valid with wrap-around behavior
    this.currentIndexValue =
      ((index % this.slideTargets.length) + this.slideTargets.length) %
      this.slideTargets.length;
    this.updateCarousel();
  }

  // Update the carousel display
  updateCarousel() {
    if (this.slideTargets.length === 0) return;

    // Calculate dimensions for slides based on container width
    const containerWidth = this.element.querySelector(
      ".carousel-container",
    ).offsetWidth;
    const slideGap = this.slideGapValue;

    // Calculate offset for current slide
    const slideWidth = this.slideTargets[0].offsetWidth;
    const offset = (slideWidth + slideGap) * this.currentIndexValue;

    // Update transform with a smooth transition
    this.trackTarget.style.transform = `translateX(-${offset}px)`;
  }
}
